import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Optional, Output } from '@angular/core';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { OrderEntry, SubEntry } from '@spartacus/cart/base/root';
import { OrderModificationPayload } from '../../model';
import { UdxCartItemListComponent } from './cart-item-list.component';
import { UDXValidators } from '../../checkout-group-sales/utils/UDXValidators';
import { Order } from '@spartacus/order/root';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgClass, AsyncPipe, CurrencyPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MediaComponent } from '@spartacus/storefront';
import { Udxb2bItemCounterComponent } from '../../item-counter/item-counter.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatOptionModule } from '@angular/material/core';
import { TranslatePipe, CxDatePipe, UrlPipe } from '@spartacus/core';
import { DayjsFormatPipe } from '../../../utilities/date/dayjs-format.pipe';

@Component({
    selector: 'cx-modify-order-cart-item-list',
    templateUrl: './modify-order-cart-item-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ReactiveFormsModule, NgClass, FormsModule, RouterLink, MediaComponent, Udxb2bItemCounterComponent, MatFormFieldModule, MatInputModule, MatDatepickerModule, MatProgressSpinnerModule, MatSelectModule, MatOptionModule, MatCheckboxModule, AsyncPipe, CurrencyPipe, TranslatePipe, CxDatePipe, UrlPipe, DayjsFormatPipe]
})
export class UdxModifyOrderCartItemListComponent extends UdxCartItemListComponent {
  
  udxValidators = new UDXValidators();
  private _orderEntryCheckboxSelected: string = '0';
  _shouldDisplaySelectOrderEntryMessage: boolean = false;
  @Output() updatedItemsList = new EventEmitter<OrderEntry[]>();
  @Input() shouldDisplayNewVisitationDate: boolean = true;
  @Input() orderEntrySelectionType: string = 'radio'; // By default it is radio button!
  @Input() forRefundFlow: boolean = false; // By default it will be false

  @Optional() @Input() order:Order = {} as Order;
  @Input() shouldDisplayDescriptionColumn: boolean = false;
  get orderEntryCheckboxSelected(): string {
    // Raj: We are happy as long as the UI does not read selection values from the model (2-way binding). As of now we only need checked event from UI to model.
    return this._orderEntryCheckboxSelected;
  }
  set orderEntryCheckboxSelected(newVal: string) {
    // For radio button
    // Raj: Radio button selection gives the 'value' of the selected radio button. This we are translating it into the "checkboxSelected"'s true or false value in the OrderEntry objects
    this._orderEntryCheckboxSelected = newVal;
    this._items.forEach((anOrderEntry: OrderEntry) => {
      if (anOrderEntry.entryNumber != undefined && anOrderEntry.entryNumber == (newVal as unknown as number)) {
        // Raj: For deselection also the same section is invoked in case of a checbox!
        anOrderEntry.checkboxSelected = true;
      } else {
        anOrderEntry.checkboxSelected = false;
      }
    });
    this.refreshOrderEntriesAndSubEntriesList();
  }

  checkboxSelectionChanged() {
    // For checkbox scenario.
    // Raj: By the time function is called the orderEntry's checkboxSelected property will already be updated by the virtue of 2 way binding
    this.refreshOrderEntriesAndSubEntriesList();
  }

  refreshOrderEntriesAndSubEntriesList() {
    this._shouldDisplaySelectOrderEntryMessage = true;
    this._items.forEach((anOrderEntry: OrderEntry) => {
      if (!anOrderEntry.checkboxSelected) {
        anOrderEntry.subEntries?.forEach((aSubEntry: SubEntry) => {
          // Reset subEntry selections for radio button which got disabled!
          aSubEntry.selected = false;
        });
      } else {
        this._shouldDisplaySelectOrderEntryMessage = false;
      }
    });
    this.sendUpdatedList(this._items);
  }

  public onSubEntrySelecitonChange(arg: MatCheckboxChange, subEntry: SubEntry, orderEntry: OrderEntry) {
    this._items.forEach((anOrderEntry: OrderEntry) => {
      if (anOrderEntry.entryNumber === orderEntry.entryNumber) {
        anOrderEntry.subEntries?.forEach((aSubEntry: SubEntry) => {
          if (aSubEntry.ticketCode === subEntry.ticketCode) {
            aSubEntry.selected = arg.checked;
          }
        });
      }
    });
    this.sendUpdatedList(this._items);
  }

  protected override resolveItems(items: OrderEntry[]): void {
    // Raj: Overriding super's implementation as we do not need grouping of order entries in modify order
    this._items = [];
    items.forEach((anOrderEntry: OrderEntry) => {
      let singleEntry: OrderEntry = Object.assign({ selected: false }, anOrderEntry);
      singleEntry.checkboxSelected = false;
      this.setDateAndTimeVisit(singleEntry, anOrderEntry.ticketEntryInfo!, anOrderEntry.packageEntryInfo!);
      singleEntry.unitPriceDisplayString = anOrderEntry.basePrice?.formattedValue;
      singleEntry.ticketCodesDisplayString = anOrderEntry.ticketCodes?.join(', ');
      // Raj: Need to do the below as OOTB the selected and disabled properties do not exist
      var newSubEntries: SubEntry[] = [];
      singleEntry.subEntries?.forEach((outOfTheBoxSubEntry: SubEntry) => {
        let customSubentry: SubEntry = Object.assign(
          {
            selected: false,
            disabled: false,
          },
          outOfTheBoxSubEntry
        );
        newSubEntries.push(customSubentry);
      });
      singleEntry.subEntries = newSubEntries;
      this._items.push(singleEntry);
    });
    this.sendUpdatedList(this._items);
  }

  sendUpdatedList(value: OrderEntry[]) {
    // var selectedOrderEntryAndSubentries:OrderEntry[] = [];
    // Creating a copy of the array:
    let copyArray = value.map((x) => Object.assign({}, x));
    let selectedOrderEntryAndSubentries = copyArray.filter((anObjectEntry) => anObjectEntry.checkboxSelected === true);
    selectedOrderEntryAndSubentries.forEach((anOrderEntry: OrderEntry) => {
      // Send only selected subentries
      let copySubEntriesArray = anOrderEntry.subEntries?.map((x) => Object.assign({}, x));
      if (copySubEntriesArray)
        anOrderEntry.subEntries = copySubEntriesArray.filter((aSubEntry) => aSubEntry.selected === true);
    });

    this.updatedItemsList.emit(selectedOrderEntryAndSubentries);
  }

  override onPickerToggle(entry: OrderEntry, orderModificationPayload?: OrderModificationPayload, referCanBeVisited = false): void {
    let orderModification: OrderModificationPayload = {
      currentPrice: entry.basePrice?.value?.toString(),
      orderNumber: entry.orderCode,
    };
    super.onPickerToggle(entry, orderModification, true);
  }

  override dateSelected(date: MatDatepickerInputEvent<Date>, groupedOrderEntry: OrderEntry) {
    super.dateSelected(date, groupedOrderEntry);

    // We need to note the price difference in terms of unit price
    if (date.value) {
      const selectedDate = this.dateToString(new Date(date.value)).trim();
      const calendarDates = groupedOrderEntry.availableTimeSlotAndPrice?.get(groupedOrderEntry.product?.code!);
      const pricing = calendarDates
        .filter((cal: { date: string }) => cal.date === selectedDate)
        .flatMap((obj: { pricing: [] }) => obj.pricing);
      // alert ("Difference on this date is: " + pricing[0].difference);
      if (pricing.length) {
        groupedOrderEntry.priceDifferenceForSelectedDate = pricing[0].difference;
      }
    }
    this.sendUpdatedList(this._items);
  }

  override timeSlotSelected(event: MatSelectChange, groupedOrderEntry: OrderEntry): void {
    super.timeSlotSelected(event, groupedOrderEntry);
    this.sendUpdatedList(this._items);
  }

  getDefaultTimeSlot(timeSlots: Set<string> | undefined, groupedOrderEntry: OrderEntry) {
    let timeslot = this.getDefaultPerfomance(timeSlots);
    if (!groupedOrderEntry?.updatedSelectedTimeslot) {
      groupedOrderEntry.updatedSelectedTimeslot = timeslot ? timeslot : undefined;
      this.updateEnabledForOrderEntry(groupedOrderEntry);
    }
    this.sendUpdatedList(this._items);
    let date = '';
    if (groupedOrderEntry?.updatedSelectedDate) {
      date = this.formatVisitationDate(new Date(groupedOrderEntry.updatedSelectedDate));
    }
    const controlName = (groupedOrderEntry.baseProduct ? groupedOrderEntry.variantGroupingCode : groupedOrderEntry.product?.code) + '-time';
    const control = this.form.get(controlName);
    if (control && (!this.order?.allowedSameDayReschedule && (groupedOrderEntry?.updatedSelectedDate ? date === groupedOrderEntry?.selectedDateToVisit : true))) {
      control?.disable(); // This will disable the FormControl
    }
    else {
      control?.enable(); // This will disable the FormControl

    }
    return timeslot;
  }

  validateIfDisabled(subEntry: SubEntry) {
    // Raj: Mocking to enable the dialog for refund flow
    // return false;
    if (this.forRefundFlow) {
      return (!subEntry.refundAble && !(this.superUser && subEntry.overrideAble)) || subEntry.redeemed; // USJT-10686: Refundable only if not redeemed already!
    }
    return (subEntry.status != 'CONFIRMED' || !subEntry.exchangeAble);
  }

  getPriceDifferenceTotalForOrderEntry(item: OrderEntry) {
    var priceDifferenceTotal = 0;
    if (item.subEntries && item.priceDifferenceForSelectedDate) {
      priceDifferenceTotal = item.subEntries!.length * item.priceDifferenceForSelectedDate!;
    }
    return priceDifferenceTotal;
  }
  
}
